import React, {useState} from 'react'
import { BasicModal } from '../../../../components/Shared'
import { Button, Tab } from 'semantic-ui-react'
import "./asesor.scss";
import {AsesorBioeliteForm, ListBioeliteAsesor} from "../../../../components/Admin/Bioelite/Asesor"

export function AsesorBioelite() {

  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(false);
  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onReload = () => setReload((prevState) => !prevState);
  const panes=[
    {
      render: () => (
        <Tab.Pane attached={false}>
          <ListBioeliteAsesor actividad="nueva" reload={reload} onReload={onReload}/>
        </Tab.Pane>
      )
    }
  ]
  return (
    <>
      <div className='cotizacion-page'>
        <div className="cotizacion-page__buttons">
          <Button className='cotizacion-page__new' value="nueva" primary onClick={()=> onOpenCloseModal('nueva')}>Nueva Cotización</Button>
        </div>
        <Tab menu={{secondary: true}} panes={panes}/> 
      </div>
      <BasicModal show={showModal} close={onOpenCloseModal} title='Crear cotización Bioelite'>
        <AsesorBioeliteForm onClose={onOpenCloseModal} onReload={onReload} />
      </BasicModal>
    </>
  )
}
